import React from "react";

import CheckWithDateIntake from "../CheckWithDateIntake";
import { Box, Modal } from "@mui/material";
import EditIntakeForm from "../forms/EditIntakeForm";
import { useState } from "react";
import { format } from "date-fns";
import EditButtonMobile from "../Buttons/EditButtonMobile";

function FormLine2Mobile(props) {
  const styleModalGeneral2 = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "80%",
    height: "80%",
    borderRadius: 5,
    // overflowY: "scroll",
    backgroundColor: "white",
    /*border: "1px solid #000",*/
    boxShadow: 24,
  };

  const [openEditIntakeForm, setopenEditIntakeForm] = useState(false);

  const handleOpenEditIntakeForm = () => setopenEditIntakeForm(true);

  const handleCloseEditIntakeForm = () => setopenEditIntakeForm(false);

  function formatDate(timestamp) {
    if (!timestamp || !timestamp.seconds) return "";

    const milliseconds =
      timestamp.seconds * 1000 + timestamp.nanoseconds / 1000000;
    const date = new Date(milliseconds);

    if (isNaN(date)) return "";

    return format(date, "d MMMM yyyy"); // "d" pour le jour, "MMMM" pour le mois en texte, "yyyy" pour l'année
  }

  function formatSignedOn(timestamp) {
    if (!timestamp || !timestamp.seconds) return "";
    const date = new Date(
      timestamp.seconds * 1000 + (timestamp.nanoseconds || 0) / 1000000
    );
    return isNaN(date) ? "" : format(date, "d MMM yyyy, HH:mm");
  }

  return (
    <div
      className={
        props.color === "1"
          ? "formLineMobile2 light-grey-form"
          : "formLineMobile2 grey-form"
      }
    >
      <Modal
        open={openEditIntakeForm}
        onClose={handleCloseEditIntakeForm}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleModalGeneral2}>
          <EditIntakeForm closemodal={handleCloseEditIntakeForm} {...props} />
        </Box>
      </Modal>
      <div className="formLineBlock1-mobile">{props.title}</div>
      <div className="formLineBlock2-mobile">
        <CheckWithDateIntake
          checked={props.signed ? "checked" : ""}
          content={formatDate(props.dateOfAdmission)}
          signedOnContent={formatSignedOn(props.signedOn)}
        />
      </div>
      <div className="formLineBlock3-mobile">
        {/* {props.signed === "signed" ? <ViewButton /> : ""} */}
        {props.signed === true ? (
          <EditButtonMobile handleOpen={handleOpenEditIntakeForm} />
        ) : (
          ""
        )}

        {/* <PrintButton />
        <MailButton /> */}
      </div>
    </div>
  );
}

export default FormLine2Mobile;
